import React from 'react';
import { CommissionsWorkspace } from '../components/CommissionsWorkspace';
import { currentOfficerId } from '../data/officers';
interface MyCommissionsProps {
  isAdmin: boolean;
  simulateLoadError: boolean;
}

/** The signed-in user's own commission statement. */
export function MyCommissions({
  isAdmin,
  simulateLoadError
}: MyCommissionsProps) {
  return <CommissionsWorkspace officerId={currentOfficerId} isAdmin={isAdmin} simulateLoadError={simulateLoadError} data-id="element-575" data-mp="dosl9iibrj5b" />;
}